/* eslint-disable */

const buildLocalDate = (year, month, day) => {
  const date = new Date(year, month - 1, day);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getDefaultOperationDate = () => new Date();

export const isValidOperationDate = (date) =>
  date instanceof Date && !Number.isNaN(date.getTime());

export const toDateOnlyString = (date) => {
  if (!isValidOperationDate(date)) return "";

  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, "0");
  const day = String(date.getDate()).padStart(2, "0");

  return `${year}-${month}-${day}`;
};

export const toLocalDateOnlyString = toDateOnlyString;

export const getTodayDateOnlyString = () => toDateOnlyString(new Date());

export const parseDateOnlyToLocalDate = (value) => {
  if (!value) return null;
  if (isValidOperationDate(value)) {
    return buildLocalDate(
      value.getFullYear(),
      value.getMonth() + 1,
      value.getDate()
    );
  }

  const raw = String(value).trim();
  const match = /^(\d{4})-(\d{2})-(\d{2})/.exec(raw);
  if (match) {
    return buildLocalDate(Number(match[1]), Number(match[2]), Number(match[3]));
  }

  const parsed = new Date(raw);
  if (!isValidOperationDate(parsed)) return null;

  return buildLocalDate(
    parsed.getFullYear(),
    parsed.getMonth() + 1,
    parsed.getDate()
  );
};

export const dateOnlyFromDateTime = (value) => {
  const parsed = parseDateOnlyToLocalDate(value);
  return parsed ? toDateOnlyString(parsed) : "";
};

const normalizeDateOnly = (date) => {
  const parsed = parseDateOnlyToLocalDate(date);
  return parsed ? parsed.getTime() : null;
};

export const isFutureOperationDate = (date) => {
  const dateTime = normalizeDateOnly(date);
  const todayTime = normalizeDateOnly(new Date());
  if (dateTime == null || todayTime == null) return false;
  return dateTime > todayTime;
};

export const isBeforeMinOperationDate = (date, minDate) => {
  const dateTime = normalizeDateOnly(date);
  const minTime = normalizeDateOnly(minDate);
  if (dateTime == null || minTime == null) return false;
  return dateTime < minTime;
};
